import React from 'react'

import _ from 'lodash'

import Box from 'components_new/atoms/Box'

export const Highlighted = React.memo(
  (props: {
    text: string
    highlight?: string | null
    // Match across whitespace in the text, so "1234" marks "1 234". For
    // searches that ignore whitespace themselves.
    ignoreWhitespace?: boolean
  }) => {
    return getHighlightedMatch(props.text, props.highlight, {
      ignoreWhitespace: props.ignoreWhitespace
    })
  }
)

export const getHighlightedMatch = (
  text: string,
  highlight?: string | null,
  options?: { ignoreWhitespace?: boolean }
) => {
  if (!highlight || !highlight.trim()) {
    return <Box component="span">{text}</Box>
  }

  const pattern = options?.ignoreWhitespace
    ? [...highlight.replace(/\s/g, '')]
        .map((char) => _.escapeRegExp(char))
        .join('\\s*')
    : _.escapeRegExp(highlight)

  const parts = text.split(new RegExp(`(${pattern})`, 'gi'))
  // A separate expression to test with: a global one carries its lastIndex
  // between calls and would skip every other match.
  const isMatch = new RegExp(`^${pattern}$`, 'i')

  return (
    <Box component="span">
      {parts
        .filter((part) => part)
        .map((part, i) =>
          isMatch.test(part) ? (
            <Box
              component="mark"
              sx={{
                bgcolor: 'primary.transparent',
                color: 'primary.text',
                p: 0
              }}
              key={i}
            >
              {part}
            </Box>
          ) : (
            <Box component="span" key={i}>
              {part}
            </Box>
          )
        )}
    </Box>
  )
}
